import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { CotecnaUserService } from "@cotecna/session";

@Injectable({
  providedIn: "root",
})
export class LoggedInGuard implements CanActivate {
  constructor(
    private connectedUserService: CotecnaUserService,
    private router: Router,
  ) {}

  canActivate() {
    if (!this.connectedUserService.isConnected()) {
      this.router.navigate(["/session/login"]);
    } else {
      return true;
    }
  }
}
